// extracted by mini-css-extract-plugin
export default {"container":"style_container__W3h9F"};